import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

import { DOCUMENTS_URL, DOCUMENTS_DETAIL_URL, DOC_UPLOAD_NEW_URL, DOC_REQUEST_NEW_URL } from 'src/constants/constants.js';
import { DocumentsTableContainer } from 'src/ui/features/Documents/containers';
import DocumentsDetailContainer from 'src/ui/features/Documents/containers/DocumentsDetailContainer';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const DocUpload = lazy(() => import('src/ui/features/Documents/containers/DocUploadContainer'));
const RequestUploadContainer = lazy(() => import('src/ui/features/Documents/containers/RequestUploadContainer'));

const DocumentsLandingPres = () => (
  <Suspense fallback={<ServiceSpinner open={true} />}>
    <Switch key="router">
      <Route
        path={`${DOC_UPLOAD_NEW_URL}/:caseManagerId?/:clientId?/:docGroupId?/:docTypeId?/:caseDocumentTypeId?`}
        component={DocUpload}
      />
      <Route path={`${DOC_REQUEST_NEW_URL}/:caseManagerId?/:clientId?/:docGroupId?/:docTypeId?`} component={RequestUploadContainer} />
      <Route
        path={DOCUMENTS_DETAIL_URL + '/:caseManagerId/:documentid/:caseDocumentTypeId/:documentTypeId/:documentGroupId'}
        component={DocumentsDetailContainer}
      />
      <Route path={DOCUMENTS_DETAIL_URL + '/:documentid/:caseDocumentTypeId'} component={DocumentsDetailContainer} />
      <Route path={DOCUMENTS_URL} component={DocumentsTableContainer} />
    </Switch>
  </Suspense>
);

export default DocumentsLandingPres;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/DocumentsLandingPres.js